export default {
  labels: {
    invoice: 'Lasku',
    on_site: 'Maksa paikan päällä (käteinen/kortti)',
  },
};
